/**
 * Created by Andrey Popov on 23.06.2026
 */

const QuestNotificationView = function (quest, options, questsIcon) {
    return Prefab.instantiate(bundles.questnotification.jsons.quest_notification_prefab_json, {
        quest,
        options,
        questsIcon
    });
};

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    QUEST_NOTIFICATION_TITLE: {
        size: 46,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    QUEST_NOTIFICATION_PROGRESS: {
        size: 46,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    }
});
